<template>
  <v-container v-if="isStaging" fluid class="label">
    STAGING ENV
    <v-icon
      small
    >report_problem</v-icon>
  </v-container>
</template>

<script>
export default {
    computed: {
        isStaging: function() {
            return process.env.BUILD_ENV === 'staging'
        }
    }
}
</script>

<style scoped>
.label {
  background-color: orange;
  color: #2c3e50;
  font-weight: bold;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/StagingLabel.vue